import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { DialogPopup } from "../../../components/DialogPopup";
import InfoIcon from "../../../images/icons/InfoIcon.svg";
import TrashIcon from "../../../images/icons/TrashIcon.svg";
import {
  BtnGroupStyle,
  BtnIconStyle,
  DataGridListStyle,
  HtmlTooltip,
} from "../../../Theme";
import { v4 as uuid } from "uuid";
import { YSButton } from "../../../uikit/YSButton";
import ConfirmPopup from "../../../components/ConfirmPopup";
import { RemoveRxFillById, RxFillList } from "../../../Apis/AuthApiServices";
import YSSnackBar from "../../../uikit/YSSnackBar";
import NoRecords from "../../../components/NoRecords";
import { useNavigate } from "react-router";
import ErrorOverlay from "../../../components/ErrorOverlay";
import useFetch from "../../../CustomHooks/useFetch";
import { loadingTopRibbon } from "../../../Redux/Slice/TopRibbonSlice";
import { useDispatch } from "react-redux";
import { Tooltip } from "@mui/material";
import { TextNA, TextNTooltip } from "../../../components/Content";

export default function RxFillDetails(props: any) {
  const { docId, docName, setShowFlow } = props;
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [selectionData, setSelectionData] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [deleteHoldingPopup, setDeletePopup] = useState(false);
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("doctorId", docId);
      params.append("rxFillIds", selectionData);
      const result = await RemoveRxFillById(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        fetchApi();
        dispatch(loadingTopRibbon());
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const handleShowDeletePopupClick = () => {
    setDeletePopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeletePopup(false);
  };
  const columns: GridColDef[] = [
    {
      field: "patientName",
      headerName: "Patient",
      width: 150,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: ({ row }) => (
        <TextNTooltip Text={row.patientFirstName + " " + row.patientLastName} />
      ),
    },
    {
      field: "drugDrescription",
      headerName: "Drug",
      width: 180,
      cellClassName: "w40",
      headerClassName: "w40",
      renderCell: ({ row }) => <TextNTooltip Text={row?.drugDrescription} />,
    },
    {
      field: "rxFillDate",
      headerName: "RxFill Date ",
      width: 180,
      cellClassName: "w10",
      headerClassName: "w10",
      renderCell: ({ row }) => <TextNA Text={row?.rxFillDate} />,
    },
    {
      field: "rxFillStatus",
      headerName: "RxFill Type",
      width: 110,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: ({ row }) => <TextNA Text={row?.rxFillStatus} />,
    },
  ];

  let paramsData = {
    pageNumber: page,
    doctorId: localStorage.getItem("doctorId"),
    selectedUserId: docId,
    pageSize: pageSize,
  };

  const { data, error, loading, fetchApi }: any = useFetch(
    paramsData,
    RxFillList,
    [page]
  );

  const [rowCountState, setRowCountState] = useState(
    data[0]?.pagination?.totalItems || 0
  );

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      data[0]?.pagination?.totalItems !== undefined
        ? data[0]?.pagination?.totalItems
        : prevRowCountState
    );
  }, [data[0]?.pagination?.totalItems, setRowCountState]);

  const MainDoctor = localStorage.getItem("DoctorName");
  return (
    <>
      <Grid
        item
        xs={12}
        md={6}
        textAlign={{ xs: "center", md: "right", lg: "right" }}
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            columnGap: 30,
          }}
        >
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              columnGap: 5,
            }}
          >
            {" "}
            <Typography component="span" color="primary" variant="body2">
              Provider
            </Typography>{" "}
            <Typography component="span" variant="body2">
              {docName === "My Own Prescriptions"
                ? MainDoctor?.toUpperCase()
                : docName?.toUpperCase()}
            </Typography>{" "}
          </Box>{" "}
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              columnGap: 5,
            }}
          >
            <Typography component="span" variant="body2">
              Selected ({selectionData.length})
            </Typography>

            <BtnIconStyle>
              <Tooltip title="Delete">
                <IconButton
                  type="button"
                  className="trash"
                  onClick={handleShowDeletePopupClick}
                >
                  <img src={TrashIcon} alt="Delete" loading="lazy" />
                </IconButton>
              </Tooltip>
            </BtnIconStyle>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} marginBottom={1}>
        <DataGridListStyle>
          <DataGrid
            rows={data[0]?.items ?? []}
            headerHeight={36}
            sortingOrder={["desc", "asc"]}
            columns={columns}
            autoHeight
            rowHeight={40}
            pageSize={pageSize}
            disableSelectionOnClick
            checkboxSelection
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            paginationMode="server"
            getRowId={(row) => row.rxfillId ?? uuid()}
            loading={loading}
            components={{
              NoRowsOverlay: NoRecords,
              NoResultsOverlay: NoRecords,
              ErrorOverlay: ErrorOverlay,
            }}
            error={error || undefined}
            rowCount={rowCountState}
            page={page}
            rowsPerPageOptions={[pageSize]}
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
            onSelectionModelChange={(ids: any) => {
              setSelectionData(ids);
            }}
            onRowClick={({ row }) => {
              navigate("/rxfillreview", {
                state: {
                  rowData: row,
                },
              });
            }}
          />
        </DataGridListStyle>
      </Grid>
      <Grid item xs={12} my={2}>
        <BtnGroupStyle className="middle">
          <YSButton
            className=""
            children={"Back"}
            variant={"outlined"}
            size={"large"}
            onClick={() => {
              setShowFlow(false);
            }}
          />{" "}
        </BtnGroupStyle>
      </Grid>{" "}
      <DialogPopup
        windowsize={"sm"}
        show={deleteHoldingPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
